'use client';
import { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { PILL_BUTTON_CLASS } from '@/utils/pillButton';

/**
 * `variant="menu"` (default): riga full-width con icona+label, per liste nav/sidebar
 * (dashboard, admin). `variant="icon"`: pulsante quadrato compatto, per header di
 * siti marketing — stesso ingombro/raggio/hover di LanguageSwitcher, per stare
 * affiancati senza stonare.
 *
 * @param {{ storageKey?: string, variant?: 'menu' | 'icon', className?: string }} props
 */
export function ThemeToggle({ storageKey = 'vs-theme-mode', variant = 'menu', className = '' }) {
  const [mode, setMode] = useState('light');

  useEffect(() => {
    const saved = localStorage.getItem(storageKey) || 'light';
    setMode(saved);
    document.documentElement.setAttribute('data-mode', saved);
  }, [storageKey]);

  function toggle() {
    const next = mode === 'light' ? 'dark' : 'light';
    setMode(next);
    document.documentElement.setAttribute('data-mode', next);
    localStorage.setItem(storageKey, next);
  }

  const title = mode === 'light' ? 'Passa a dark' : 'Passa a light';

  if (variant === 'icon') {
    return (
      <button
        onClick={toggle}
        title={title}
        aria-label={title}
        className={[PILL_BUTTON_CLASS, className].join(' ')}
      >
        {mode === 'light' ? <Moon size={14} /> : <Sun size={14} />}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      title={title}
      className={[
        'flex items-center gap-2 px-3 py-2 w-full rounded text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] hover:bg-[var(--color-bg-surface-2)] transition-all cursor-pointer',
        className,
      ].join(' ')}
      style={{ border: 'none', background: 'transparent' }}
    >
      {mode === 'light' ? <Moon size={14} /> : <Sun size={14} />}
      {mode === 'light' ? 'Dark mode' : 'Light mode'}
    </button>
  );
}
